import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Input, Button } from 'antd'

@inject((store: any) => {
    const { popupStore, policyCollectionsStore } = store
    return { popupStore, policyCollectionsStore }
})
@observer
class DeletePolicyCollectionPopup extends Component<any, any> {
    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    deleteConnection = async () => {
        try {
            await this.props.policyCollectionsStore.deleteCollection(
                this.props.location.pathname.split('/').pop(),
                JSON.parse(JSON.stringify(this.props.policyCollectionsStore.collection)).name.id
            )
            await this.props.policyCollectionsStore.getList(this.props.location.pathname.split('/').pop())
            this.closePopup()
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        const { popupStore, policyCollectionsStore } = this.props

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>ביטול</Button>
                    <Button type="primary" onClick={() => this.deleteConnection()}>
                        אישור
                    </Button>
                </div>
            </div>
        )

        return (
            <Modal
                title={`מחק את הקשר בין ${
                    JSON.parse(JSON.stringify(policyCollectionsStore.collection)).name
                        ? JSON.parse(JSON.stringify(policyCollectionsStore.collection)).name.name
                        : ''
                } לבין ${policyCollectionsStore.policy}`}
                visible={popupStore.popupType === 'deletePolicyCollection'}
                onCancel={this.closePopup}
                footer={footerButtons}
            ></Modal>
        )
    }
}

export default withRouter(DeletePolicyCollectionPopup)
